import type { TranslationModule } from '../types';

export const perspectiveTranslations: TranslationModule = {
  ro: {
    choose: "-- Alegeți --",
    selectMaterie: "1. Selectați Materia",
    chooseMaterie: "-- Alegeți Materia --",
    selectObiect: "2. Selectați Obiectul Juridic",
    chooseObiect: "-- Alegeți Obiectul --"
  },
  en: {
    choose: "-- Select --",
    selectMaterie: "1. Select Legal Field",
    chooseMaterie: "-- Select Legal Field --",
    selectObiect: "2. Select Legal Subject",
    chooseObiect: "-- Select Legal Subject --"
  },
  fr: {
    choose: "-- Choisir --",
    selectMaterie: "1. Sélectionnez la matière",
    chooseMaterie: "-- Choisir la matière --",
    selectObiect: "2. Sélectionnez l'objet juridique",
    chooseObiect: "-- Choisir l'objet --"
  }
};

export default perspectiveTranslations;
